// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFound_container__3cdva","BackArrow":"NotFound_BackArrow__1c9aV"};